export const appointmentTypeDurations = {
    'In-Person': [60, 120],
    'Virtual': [15, 30, 60],
    'Phone': [15, 30, 60]
}